export default __webpack_public_path__ + "static/media/Perk_4.ffee58a1.png";